module.exports = __webpack_public_path__ + "img/3x.bd8d69f.jpg";